<template>
  <b-sidebar
    id="sidebar-create-quote-distribution"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Quote distribution') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="quoteDistributionCreate">
          <!-- Short info -->
          <b-form-group
            :label="$t('Description')"
            label-for="about"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Description')"
              rules="required"
            >
              <b-form-textarea
                id="shortInfo"
                v-model="quoteDistribution.about"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Period -->
          <b-form-group
            :label="$t('Period')"
            label-for="period"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Period')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="quoteDistribution.period"
                :reduce="(option) => option.id"
                :options="periods"
                :get-option-label="(option) => option.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="quoteDistribution.id ? 'primary' : 'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ quoteDistribution.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    quoteDistribution: {
      get() {
        return this.$store.state.quoteDistribution.quoteDistribution
      },
      set(data) {
        this.$store.commit('quoteDistribution/UPDATE', data)
      },
    },
    periods() {
      return this.$store.state.period.periods
    },
  },
  mounted() {
    this.$store.dispatch('period/list', { status: 'True', step: this.$store.state.staticModule.stepInnovationQuoteDistribution })
    localize(this.$i18n.locale)
    this.freshData()
  },
  methods: {
    clear(hide) {
      this.freshData()
      hide()
    },
    freshData() {
      this.$store.commit('quoteDistribution/FRESH', { total_quote_type: this.$store.state.staticModule.totalQuoteTypeGive })
      this.$refs.quoteDistributionCreate.reset()
    },
    submit(hide) {
      this.$refs.quoteDistributionCreate.validate().then(success => {
        if (success) {
          this.$confirmCode({
            callback: (confirm, smsCode) => {
              if (confirm) {
                this.$createSwal(this, { ...this.quoteDistribution, smsCode }, `quoteDistribution/${this.quoteDistribution.id ? 'update' : 'create'}`, res => {
                  this.$emit('refetchData')
                  this.$store.commit('quoteDistribution/FRESH')
                  if (res.data.id) this.$router.push({ name: 'quote-distribution-view', params: { id: res.data.id } })
                })
                hide()
              }
            },
          })
        }
      })
    },
  },
}
</script>
